module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_1#rch1"
    }
  }, [_vm._v("Sample Material")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_2#rch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teacher’s Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_2#rch2s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_3#rch2s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise For John Irving’s "), _c('i', [_vm._v("A Prayer For Owen Meany")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_4#rch2s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About This Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_5#rch2sa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Following and Understanding The Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch2s4-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_5#rch2s4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Written Response")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch2s4-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_5#rch2s4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions for Class Discussion and Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch2s4-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_5#rch2s4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research and Essay Topics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Chapter_6#rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes on the Novel’s Secondary Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "buy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Buy_Book#rbuy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buy the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#rata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cpy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062374295_Copyright#rcpy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#ratp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12657ca0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062374295_Contents.vue
// module id = 63
// module chunks = 0